export default __webpack_public_path__ + "static/media/Currencies.188ab60f.svg";